// localStorage key for cache
export const LS_KEY_CACHE = 'szn:idnts:cch';
// events name
export const EVENT_NAME = 'szn:identities';
export const EVENT_NAME_BEFORE_UPDATE = 'szn:identities:beforeupdate';
export const EVENT_NAME_READY = 'szn:identities:ready';
export const EVENT_FROM_TOP_NAME = 'szn:identities:fromtop';
export const EVENT_TO_TOP_NAME = 'szn:identities:totop';
// cache max age
export const CACHE_MAX_AGE = 1000 * 60 * 60;
// global timeout for identitites to be settled
export const TIMEOUT = 5000;
// premature timeout (login)
export const TIMEOUT_PREMATURE_LOGIN = 1000;
// default "get" rules
export const DEFAULT_GET_RULES = { rich: false, justSettled: true, cacheEnough: false };
// id5
export const ID5_URL = 'https://cdn.id5-sync.com/api/1.0/id5-api.js';
